import { Grid } from "@mui/material";
import MapPanel from "./MapPanel";
import CountByCountryPanel from "./CountByCountryPanel";
import IntelIpsPanel from "./IntelIpsPanel";
import DnsRequestsPanel from "./DnsRequestsPanel";

const IntelligenceTab = ({
  mapCountryData,
  externalIps,
  dnsCountData,
  dnsCountLoading,
  products,
}) => {
  const PAPER_SX = {
    height: "100%",
    p: 2,
    backgroundColor: "#1e1e1e",
    borderRadius: "15px",
    backgroundImage: 'none'
  };
  
  return (
  <Grid container spacing={2} alignItems="stretch">
    <Grid size={{ xs: 12, md: 4 }}>
      <MapPanel paper_sx={PAPER_SX}/>
    </Grid>
    <Grid size={{ xs: 12, md: 8 }}>
      <CountByCountryPanel mapCountryData={mapCountryData} paper_sx={PAPER_SX}/>
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <IntelIpsPanel
        externalIps={externalIps}
        paper_sx={PAPER_SX}
      />
    </Grid>
    <Grid size={{ xs: 12, md: 6 }}>
      <DnsRequestsPanel
        dnsCountData={dnsCountData}
        dnsCountLoading={dnsCountLoading}
        products={products}
        paper_sx={PAPER_SX}
      />
    </Grid>
  </Grid>
)};

export default IntelligenceTab;
